<template>
  <div class="section-head" :id="'section-head--' + this.patient">

    <div class="section-head_image">
      <img v-if="this.patient === 'susan'" src="@/assets/img/patients/susan/susan_2.png" class="sh-image" alt>
      <img v-if="this.patient === 'joseph'" src="@/assets/img/patients/joseph/joseph_2.png" class="sh-image" alt>
      <img v-if="this.patient === 'gabrielle'" src="@/assets/img/patients/gabrielle/gabrielle_0.png" class="sh-image" alt>
    </div>

    <div class="section-head-wrapper">

      <div class="section-head_content">

        <div class="sh-name_container">
          <p class="sh-name" v-html="this.patients[this.patient].name + '*'"></p>
        </div>

        <div class="sh-divider"></div>

        <div class="sh-text_container">
          <p class="sh-text" v-html="this.patients[this.patient].story"></p>
        </div>
      </div>

      <div class="sh-footnotes_container">
        <p class="sh-footnotes" v-html="this.sup_ml5 + this.patients[this.patient].footnotes"></p>
      </div>

    </div>

  </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: 'SectionHead',
  data() {
    return {
      sup_ml5: '<span class="ml-5">*</span>'
    };
  },
  props: {
    patient: {
      type: String
    }
  },
  computed: {
    ...mapState(['userAgent', 'patients'])
  }
};

</script>

<style lang="scss">

.section-head {
  display: flex;
  flex-direction: row;
  width: 100%;
  background-image: linear-gradient(to bottom, rgba(#274375, 0.2), #274375 85%);
  min-height: 400px;
  position: relative;
  justify-content: center;

  .section-head-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 100%;
    padding: 0 20px;
    z-index: 2;
    background-image: linear-gradient(to bottom, rgba(#274375, 0.1), #274375 85%);
  }

}

.section-head_image {
  position: absolute;
  display: flex;
  flex-direction: column;
  z-index: 1;
  top: auto;
  bottom: 60px;

  .sh-image {
    width: auto;
    height: 350px;
    @include media("<phone") {
      height: 300px;
    }
    @include media("<=350px") {
      height: 250px;
    }
  }

  @include media("<=350px") {
    bottom: 120px;
  }
}

.section-head_content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

// text containers
.sh-name_container {
  display: flex;
  flex-direction: column;
  padding: 15px 0;
  align-items: center;
  justify-content: center;

  .sh-name {
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 32px;
    font-weight: normal;
    font-stretch: condensed;
    font-style: normal;
    line-height: 0.97;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    text-transform: uppercase;
  }
}

.sh-text_container {
  display: flex;
  flex-direction: column;
  padding: 15px 0 0 0;
  align-items: center;
  justify-content: center;
  width: 40%;

  @include media("<phone") {
    width: 80%;
  }

  .sh-text {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.31;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }
}

.sh-footnotes_container {
  display: flex;
  flex-direction: row;
  padding: 15px 0;

  .sh-footnotes {
    font-family: 'Roboto', sans-serif;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.08;
    letter-spacing: normal;
    color: #ffffff;
  }
}

.sh-divider {
  width: 50%;
  height: 1px;
  opacity: 0.22;
  background-color: #FFFFFF;
}

</style>
